export default "__VITE_ASSET__CrYAzvIi__"